module.exports = __webpack_public_path__ + "static/img/footer-montagne.39a4d1ff.png";